module.exports = __webpack_public_path__ + "img/mon.03f10492.svg";